module.exports = __webpack_public_path__ + "img/circuits.94080aee.jpg";